<template>
	<Modal
		:show="showRequestFinance"
		content_class="col-12 col-md-10 col-lg-8 col-xl-7 request-invoice-finance"
	>
		<template slot="content">
			<div>
				<div class="clearfix top">
					<div class="left-content f-l">
						<div class="content-title">Request Finance</div>
					</div>
					<div
						class="close-modal f-r"
						@click="$store.commit('showRequestFinance', false)"
					>
						<i class="fa fa-times"></i>
					</div>
				</div>

				<div class="coantent" v-if="invoice_details">
					<div class="row justify-content-center">
						<div class="col-2 col-lg-1">
							<div class="stages">
								<div
									class="stage-container clearfix"
									v-for="i in 4"
									:key="i"
								>
									<div
										class="number f-l"
										:class="{
											success: i < current_finance_page,
											processing:
												i == current_finance_page,
										}"
									>
										<div class="circle">
											{{ i }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-10 col-lg-10">
							<div class="steps">
								<div class="step-body">
									<div
										class="page"
										v-show="current_finance_page === 1"
									>
										<div class="card payment-card">
											<div class="txt-main">
												You are about to be financed for
												invoice ref:
												<span class="ref">{{
													invoice_details.invoice_system_ref
												}}</span
												>. The invoice total is:
												<span class="amount"
													>{{
														invoice_details.invoice_currency
													}}
													{{
														utils.numberWithCommas(
															Math.round(
																invoice_details.invoice_amount *
																	100,
															) / 100,
														)
													}}</span
												>
												<div class=""></div>
												<br />
												Amount to be financed:
												<span class="amount"
													>{{
														invoice_details.invoice_currency
													}}
													{{
														utils.numberWithCommas(
															Math.round(
																invoice_details
																	.invoice_finance_option
																	.amt_available_for_finance *
																	100,
															) / 100,
														)
													}}</span
												>
											</div>

											<div class="balance">
												Your balance is:
												<span
													class="amount"
													:class="{
														'tx-red':
															invoice_details.invoice_amount >
															acc_balance,
													}"
													>{{
														invoice_details.invoice_currency
													}}
													{{
														utils.numberWithCommas(
															Math.round(
																acc_balance *
																	100,
															) / 100,
														)
													}}</span
												>
											</div>
										</div>

										<div class="card">
											<Form
												classBinding="row"
												:ref="
													FeeInvoiceModel.forms
														.request_finance.name
												"
												:forms="
													FeeInvoiceModel.forms
														.request_finance.forms
												"
												:formData="
													FeeInvoiceModel.forms
														.request_finance.data
												"
											/>
										</div>
									</div>
									<div
										class="page"
										v-show="current_finance_page === 2"
									>
										<div class="h4">Select Lender</div>

										<div class="page-box">
											<div class="scroll-content">
												<scrollbar>
													<div
														class="select-card policy card card-details"
														v-for="(
															lender, p
														) in lenders"
														:key="p"
														@click="
															$store.commit(
																'selected_lender',
																lender,
															);
															$store.commit(
																'selected_lender_id',
																lender.loan_product_system_ref,
															);
														"
														:class="{
															selected:
																lender.loan_product_system_ref ===
																selected_lender_id,
														}"
													>
														<!-- <div 
                                          class="select-card policy card card-details" 
                                          v-for="(lender,p) in lenders" 
                                          :key="p" 
                                          @click="$store.commit('selected_lender', lender);$store.commit('selected_lender_id', lender.lender_system_ref);"
                                          :class="{'selected': lender.lender_system_ref === selected_lender_id}"
                                       > -->
														<div class="select-box">
															<div
																class="small-box"
															>
																<i
																	class="fa fa-check"
																></i>
															</div>
														</div>
														<!-- <div class="clearfix">
                                             <div class="image-box f-l">
                                                <img :src="lender.lender_image_path && lender.lender_image_path !== '' ? api.getDomain()+ '/' + lender.logo : '/img/logo-1.png'" alt="" class="image">
                                             </div>
                                             <div class="name-box f-l">
                                                <div class="insurance">{{lender.lender_name}}</div>
                                                <div class="txt">Interest Rate: <b>{{lender.loan_product_details.interest_details.value}}</b></div>
                                                <div class="small-amount">Pautils.numberWithCommas(yment per month: <.b>{{lender.loan_product_details.payment_details.payment_amount.toLocaleString('us-US', { style: 'currency', currency: 'KES' })}}</)b></div>
                                                <Rate 
                                                   class="f-l rate"
                                                   disabled
                                                   v-model="lender.lender_rating" 
                                                   :allow-half="true"
                                                />
                                             </div>
                                          </div> -->
														<div class="clearfix">
															<div
																class="image-box f-l"
															>
																<img
																	:src="
																		lender.loan_product_img_path
																	"
																	alt=""
																	class="image"
																/>
															</div>
															<div
																class="name-box f-l"
															>
																<div
																	class="insurance tx-uppercase"
																>
																	{{
																		lender.loan_product_name
																	}}
																</div>
																<div
																	class="insurance tx-uppercase"
																>
																	Loan Amount:
																	{{
																		utils.numberWithCommas2(
																			lender
																				.loan_product_amount
																				.minimum,
																		)
																	}}
																	-
																	{{
																		utils.numberWithCommas2(
																			lender
																				.loan_product_amount
																				.maximum,
																		)
																	}}
																</div>
																<div
																	class="insurance tx-uppercase"
																>
																	Loan Tenure:
																	{{
																		lender
																			.loan_product_tenor
																			.minimum
																	}}
																	-
																	{{
																		lender
																			.loan_product_tenor
																			.maximum
																	}}
																</div>
																<div
																	class="txt"
																>
																	{{
																		lender.loan_product_description
																	}}
																</div>
															</div>
														</div>
													</div>
												</scrollbar>
											</div>
										</div>
									</div>
									<div
										class="page"
										v-show="current_finance_page === 3"
									>
										<div
											v-if="
												selected_lender &&
												lender_details
											"
										>
											<div class="card card-details">
												<div class="clearfix">
													<div class="image-box f-l">
														<img
															:src="
																selected_lender.loan_product_img_path
															"
															alt=""
															class="image"
														/>
													</div>
													<div class="name-box f-l">
														<div
															class="insurance tx-uppercase"
														>
															{{
																selected_lender.loan_product_name
															}}
														</div>
														<div
															class="insurance tx-uppercase"
														>
															Loan Amount:
															{{
																utils.numberWithCommas(
																	selected_lender
																		.loan_product_amount
																		.minimum,
																)
															}}
															-
															{{
																utils.numberWithCommas(
																	selected_lender
																		.loan_product_amount
																		.maximum,
																)
															}}
														</div>
														<div
															class="insurance tx-uppercase"
														>
															Loan Tenure:
															{{
																selected_lender
																	.loan_product_tenor
																	.minimum
															}}
															-
															{{
																selected_lender
																	.loan_product_tenor
																	.maximum
															}}
														</div>
														<div class="txt">
															{{
																selected_lender.loan_product_description
															}}
														</div>
														<Rate
															class="f-l rate"
															disabled
															:value="3.7"
															:allow-half="true"
														/>
													</div>
												</div>
											</div>

											<div class="card card-details">
												<div class="clearfix">
													<div class="image-box f-l">
														<img
															:src="
																lender_details
																	.bank_details
																	.bank_details
																	.logo &&
																lender_details
																	.bank_details
																	.bank_details
																	.logo !== ''
																	? api.getDomain() +
																		'/' +
																		lender_details
																			.bank_details
																			.bank_details
																			.logo
																	: '/img/logo-1.png'
															"
															alt=""
															class="image"
														/>
													</div>
													<div class="name-box f-l">
														<div
															class="insurance tx-uppercase"
														>
															{{
																lender_details
																	.bank_details
																	.bank_details
																	.name
															}}
														</div>
														<div class="txt">
															{{
																lender_details
																	.bank_details
																	.bank_details
																	.description
															}}
														</div>
													</div>
												</div>
											</div>

											<div class="card card-details">
												<div class="ot-title my-2">
													FEATURES
												</div>

												<div
													class="ot-text tx-blue"
													v-if="
														lender_details
															.loan_product_details
															.features.length ===
														0
													"
												>
													No Features Found
												</div>
												<div
													class="ot-text"
													v-for="(
														feature, b
													) in lender_details
														.loan_product_details
														.features"
													:key="b"
												>
													{{ b + 1 }}. {{ feature }}
												</div>

												<div class="ot-title my-2">
													REQUIREMENTS
												</div>
												<div
													class="ot-text tx-blue"
													v-if="
														lender_details
															.loan_product_details
															.requirements
															.length === 0
													"
												>
													No Requirements Found
												</div>
												<div
													class="ot-text"
													v-for="(
														requirement, b
													) in lender_details
														.loan_product_details
														.requirements"
													:key="b"
												>
													{{ b + 1 }}.
													{{ requirement }}
												</div>
											</div>

											<div class="detail-box-summary">
												<div class="row">
													<div class="col-lg-4">
														<div
															class="card card-stat"
														>
															<div
																class="cd-title"
															>
																Toal Loan
																Requests
															</div>
															<div
																class="big-num"
															>
																{{
																	lender_details
																		.loan_product_summary
																		.number_of_loan_request
																}}
															</div>
														</div>
													</div>
													<div class="col-lg-4">
														<div
															class="card card-stat"
														>
															<div
																class="cd-title"
															>
																Acceptance Rate
															</div>
															<div
																class="big-num"
															>
																{{
																	lender_details
																		.loan_product_summary
																		.disbursment_probability
																}}
															</div>
														</div>
													</div>
													<div class="col-lg-4">
														<div
															class="card card-stat"
														>
															<div
																class="cd-title"
															>
																Averrage
																disbursement
																duration
															</div>
															<div
																class="big-num"
															>
																5 Hrs
															</div>
														</div>
													</div>
												</div>
											</div>

											<!-- <div class="requirement-box">
                                    <div class="card">
                                       <div class="box-title">Requirements</div>
                                       <ol>
                                          <li class="requirement" v-for="(req, i) in schedule_summary_details.lender_details.requirements" :key="i">{{req}}</li>
                                       </ol>
                                    </div>
                                 </div> -->
										</div>
									</div>
									<div
										class="page"
										v-show="current_finance_page === 4"
									>
										<div class="card">
											<div
												class="clearfix"
												v-if="selected_lender"
											>
												<div class="image-box f-l">
													<img
														:src="
															selected_lender.loan_product_img_path
														"
														alt=""
														class="image"
													/>
												</div>
												<div class="name-box f-l">
													<div
														class="insurance tx-uppercase"
													>
														{{
															selected_lender.loan_product_name
														}}
													</div>
													<div
														class="insurance tx-uppercase"
													>
														Loan Amount:
														{{
															selected_lender.loan_product_amount.minimum.toLocaleString(
																'us-US',
															)
														}}
														-
														{{
															selected_lender.loan_product_amount.maximum.toLocaleString(
																'us-US',
															)
														}}
													</div>
													<div
														class="insurance tx-uppercase"
													>
														Loan Tenure:
														{{
															selected_lender
																.loan_product_tenor
																.minimum
														}}
														-
														{{
															selected_lender
																.loan_product_tenor
																.maximum
														}}
													</div>
													<div class="txt">
														{{
															selected_lender.loan_product_description
														}}
													</div>
												</div>
											</div>
										</div>

										<div
											class="card payment-card"
											v-if="
												schedule_summary_details &&
												selected_lender &&
												loan_application_details
											"
										>
											<div
												class="txt-main"
												v-if="selected_lender"
											>
												You are being financed by:
												{{
													selected_lender.lender_name
												}}
											</div>
											<div class="card card-details">
												<div class="clearfix">
													<div class="image-box f-l">
														<img
															:src="
																lender_details
																	.bank_details
																	.bank_details
																	.logo &&
																lender_details
																	.bank_details
																	.bank_details
																	.logo !== ''
																	? api.getDomain() +
																		'/' +
																		lender_details
																			.bank_details
																			.bank_details
																			.logo
																	: '/img/logo-1.png'
															"
															alt=""
															class="image"
														/>
													</div>
													<div class="name-box f-l">
														<div
															class="insurance tx-uppercase"
														>
															{{
																lender_details
																	.bank_details
																	.bank_details
																	.name
															}}
														</div>
														<div class="txt">
															{{
																lender_details
																	.bank_details
																	.bank_details
																	.description
															}}
														</div>
													</div>
												</div>
											</div>

											<div class="txt-box">
												<div class="row">
													<div class="col-md-6">
														<div
															class="small-title"
														>
															Application Ref
														</div>
													</div>
													<div class="col-md-6">
														<div
															class="small-amount tx-green tx-uppercase"
														>
															{{
																loan_application_details.application_system_ref
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Application Amount
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																loan_application_details.application_amount.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Application Date
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																moment(
																	loan_application_details.application_date,
																).format(
																	'Do MMM YYYY',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Due Amount
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_due_amount.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Installment
															Amount
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_installment_amount.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Interest
															Charged
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_interest_charged.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Loan Term in
															Days
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_loan_term_in_days.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Original Due
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_original_due.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<div class="col-md-8">
														<div
															class="small-title"
														>
															Total Outstanding
														</div>
													</div>
													<div class="col-md-4">
														<div
															class="small-amount"
														>
															{{
																schedule_summary_details.total_outstanding.toLocaleString(
																	'us-US',
																)
															}}
														</div>
													</div>
													<!-- <div class="col-md-8">
                                          <div class="small-title">Total Paid</div>
                                       </div>
                                       <div class="col-md-4">
                                          <div class="small-amount">{{schedule_summary_details.total_paid.toLocaleString('us-US')}}</div>
                                       </div>
                                       <div class="col-md-8">
                                          <div class="small-title">Total Waived</div>
                                       </div>
                                       <div class="col-md-4">
                                          <div class="small-amount">{{schedule_summary_details.total_waived.toLocaleString('us-US')}}</div>
                                       </div>
                                       <div class="col-md-8">
                                          <div class="small-title">Total Amount Wwritten Off</div>
                                       </div>
                                       <div class="col-md-4">
                                          <div class="small-amount">{{schedule_summary_details.total_written_off.toLocaleString('us-US')}}</div>
                                       </div> -->
												</div>
												<!-- <div class="txt">Amount: <b class="amount">{{invoice_details.currency}} {{acc_balance)}}</b></div>
                                    <div class="txt">Term: 12</div>
                                    <div class="txt">Prefered Payment: 10</div> -->
											</div>

											<div
												class="card schedule-card"
												v-if="
													application_charges &&
													application_charges.charges
														.length > 0
												"
											>
												<div class="txt-main">
													<div class="schedule">
														<h4 class="title mb-3">
															Charges
														</h4>
														<div class="row title">
															<div
																class="col-12 col-md-8"
															>
																<div
																	class="txt mb-2"
																>
																	Description
																</div>
															</div>
															<div
																class="col-6 col-md-4"
															>
																<div
																	class="txt tx-r mb-2"
																>
																	Charge
																</div>
															</div>
														</div>
														<div
															class="row"
															v-for="(
																charge, c
															) in application_charges.charges"
															:key="c"
														>
															<div
																class="col-12 col-md-8 mb-1"
															>
																<div
																	class="txt"
																>
																	{{
																		charge.charge_description
																	}}
																</div>
															</div>
															<div
																class="col-6 col-md-4 mb-1"
															>
																<div
																	class="txt tx-r"
																>
																	<b>{{
																		charge.charge_amount.toLocaleString(
																			'us-US',
																			{
																				minimumFractionDigits: 2,
																				maximumFractionDigits: 2,
																			},
																		)
																	}}</b>
																</div>
															</div>
														</div>

														<div class="total-box">
															<div class="row">
																<div
																	class="col-8 item-title"
																>
																	Total
																</div>
																<div
																	class="col-4 amount"
																>
																	{{
																		application_charges.total_charges.toLocaleString(
																			'us-US',
																			{
																				minimumFractionDigits: 2,
																				maximumFractionDigits: 2,
																			},
																		)
																	}}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="txt-main">
												<Form
													classBinding="row"
													:ref="
														FeeInvoiceModel.forms
															.loan_payment_options
															.name
													"
													:forms="
														FeeInvoiceModel.forms
															.loan_payment_options
															.forms
													"
													:form_data="
														FeeInvoiceModel.forms
															.loan_payment_options
															.data
													"
												/>

												<Form
													classBinding="row"
													:ref="
														FeeInvoiceModel.forms
															.accept_bank.name
													"
													:forms="
														FeeInvoiceModel.forms
															.accept_bank.forms
													"
													:form_data="
														FeeInvoiceModel.forms
															.accept_bank.data
													"
												/>
											</div>
										</div>
										<div class="card schedule-card">
											<div class="txt-main">
												<div class="schedule">
													<div class="title mb-3">
														Payment Scedule
													</div>
													<div class="row title">
														<div
															class="col-12 col-md-4"
														>
															<div
																class="txt mb-2"
															>
																Date
															</div>
														</div>
														<div
															class="col-6 col-md-4"
														>
															<div
																class="txt tx-r mb-2"
															>
																Principle
															</div>
														</div>
														<div
															class="col-6 col-md-4"
														>
															<div
																class="txt tx-r mb-2"
															>
																Interest
															</div>
														</div>
													</div>
													<div
														class="row"
														v-for="(
															detail, s
														) in schedule_details"
														:key="s"
													>
														<div
															class="col-12 col-md-4 mb-1"
														>
															<div class="txt">
																<b>{{
																	moment(
																		detail
																			.charges
																			.installment_date,
																	).format(
																		'Do MMM YYYY',
																	)
																}}</b>
															</div>
														</div>
														<div
															class="col-6 col-md-4 mb-1"
														>
															<div
																class="txt tx-r"
															>
																<b>{{
																	detail.principal.installment_amount.toLocaleString(
																		'us-US',
																		{
																			minimumFractionDigits: 2,
																			maximumFractionDigits: 2,
																		},
																	)
																}}</b>
															</div>
														</div>
														<div
															class="col-6 col-md-4 mb-1"
														>
															<div
																class="txt tx-r"
															>
																<b>{{
																	detail.interest.installment_amount.toLocaleString(
																		'us-US',
																		{
																			minimumFractionDigits: 2,
																			maximumFractionDigits: 2,
																		},
																	)
																}}</b>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="step-footer">
									<div
										class="btn btn-yellow"
										v-show="current_finance_page < 4"
										:disabled="loading"
										@click="
											navigateNextStepInvoice({
												request_finance:
													$refs[
														FeeInvoiceModel.forms
															.request_finance
															.name
													],
											})
										"
									>
										Next
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6">
											<div
												class="btn btn-red btn-long"
												v-show="
													current_finance_page === 4
												"
												:disabled="loading"
												@click="
													rejectFinancing({
														accept_bank:
															$refs[
																FeeInvoiceModel
																	.forms
																	.accept_bank
																	.name
															],
														loan_payment_options:
															$refs[
																FeeInvoiceModel
																	.forms
																	.loan_payment_options
																	.name
															],
													})
												"
											>
												Reject
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
										<div class="col-lg-6">
											<div
												class="btn btn-green btn-long"
												v-show="
													current_finance_page === 4
												"
												:disabled="loading"
												@click="
													acceptFinancing({
														accept_bank:
															$refs[
																FeeInvoiceModel
																	.forms
																	.accept_bank
																	.name
															],
														loan_payment_options:
															$refs[
																FeeInvoiceModel
																	.forms
																	.loan_payment_options
																	.name
															],
													})
												"
											>
												Accept
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	components: {
		Rate: () => import('@/libs/clarks/components/rate/index'),
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		scrollbar: VueScrollbar,
	},
	computed: {
		...mapGetters([
			'FeeInvoiceModel',
			'loading',
			'get_finance_data',
			'school_invoice_details_table',
			'invoice_details',
			'showRequestFinance',
			'acc_balance',
			'schedule_details',
			'loan_application_details',
			'application_charges',
			'schedule_summary_details',
			'lenders',
			'selected_lender_id',
			'selected_lender',
			'lender_details',
			'LoanModel',
			'bank_payment_schedule',
			'current_finance_page',
			'loan_payment_schedules',
		]),
	},
	data() {
		return {
			utils,
			moment,
			api,
		};
	},
	methods: {
		...mapActions([
			'acceptFinancing',
			'rejectFinancing',
			'navigateNextStepInvoice',
		]),
		getOutstandingAmount(s) {
			let due =
				s.paymentToPrinciple +
				s.paymentToInterest +
				s.feesDue +
				s.penaltiesDue;
			let payment =
				s.principalPayment +
				s.interestPayment +
				s.feePayment +
				s.penaltyPayment;

			return utils.numberWithCommas(
				Math.round(Math.abs(due - payment) * 100) / 100,
			);
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.request-invoice-finance {
	.total-box {
		border-top: solid 1px var(--border-grey);
		border-bottom: solid 1px var(--border-grey);
		padding: 7px 0;
		margin: 10px 0 0 0;
		font-weight: 600;

		.amount {
			color: var(--ne-blue);
			text-align: right;
		}
	}

	.ot-title {
		font-size: 13px;
		font-weight: 600;
	}
	.ot-text {
		font-size: 13px;
	}
	.detail-box-summary {
		margin: 0 -10px !important;
	}
	.tx-r {
		text-align: right !important;
	}
	.requirement-box {
		margin: 40px 0 0 0;

		.requirement {
			font-size: 12px;
			font-weight: 600;
		}
		.box-title {
			font-size: 13px;
			font-weight: 600;
			margin: 0 0 20px 0;
			text-transform: uppercase;
		}
	}
	.cd-title {
		font-size: 13px;
		// color: @grey;
		font-weight: 600;
	}
	.card-stat {
		height: 100%;
	}
	.big-num {
		position: absolute;
		bottom: 10px;
		font-size: 28px;
		font-family: var(--font-bolder);
	}
	.small-title {
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
	}
	.small-amount {
		text-align: right;
		font-size: 13px;
		font-weight: 600;
	}
	.smaller {
		font-size: 11px;
	}
	.row.sec {
		padding: 10px 0 !important;
	}
	.ref {
		text-transform: uppercase !important;
	}
	.schedule-title {
		font-size: 13px;
		font-weight: 600;
	}
	.schedule {
		.amount {
			text-align: right;
		}
		.status {
			text-transform: uppercase;
			font-weight: 600;
			font-size: 13px;
		}
	}

	.txt-box {
		margin: 30px 0;

		.txt {
			font-size: 13px;
			font-weight: 600;
		}
	}
	.scroll-content {
		height: calc(100vh - 250px);
	}
	.stages {
		.stage-container {
			position: relative;
			height: 120px;

			&:first-child {
				.number {
					margin-top: 30px;

					.circle {
						margin-top: -20px;
					}
				}
			}
			&:last-child {
				.number {
					margin-bottom: 90px;

					.circle {
						margin-bottom: -20px;
					}
				}
			}

			.number {
				border-left: solid 2px var(--red);
				position: absolute;
				top: 0;
				bottom: 0;

				.circle {
					margin: 10px 0 0 -17px;
					width: 30px;
					height: 30px;
					border: solid 2px var(--red);
					color: var(--red);
					padding: 4px 0 0 0;
					text-align: center;
					font-size: 15px;
					font-weight: 600;
					border-radius: 50%;
					background: var(--white);
				}

				&.success {
					border-left-color: var(--ne-green);

					.circle {
						border: solid 2px var(--ne-green);
						color: var(--ne-green);
					}
				}
				&.processing {
					border-left-color: var(--primary);

					.circle {
						border: solid 2px var(--primary);
						color: var(--primary);
					}
				}
			}

			.stage {
				background: var(--white);
				// color: var(--white);
				float: left;
				width: calc(100% - 60px);
				padding: 15px;
				margin: 10px 10px 10px 50px;
				border-radius: 3px;
				font-size: 14px;
				font-weight: 600;
			}
		}
	}
	.select-card,
	.card {
		cursor: pointer;

		.select-box {
			.small-box {
				float: right;
				font-size: 13px;
				margin: -14px -12px 0 0 !important;
				padding: 2px 0;
				width: 22px;
				height: 22px;
				text-align: center;
				background: var(--primary);
				color: var(--white);
				border-radius: 50%;
				display: none;
			}
		}
		.small-amount {
			font-size: 12px;
		}
		.rate {
			font-size: 13px;
		}
		.image {
			max-width: 90px;
			max-height: 90px;
			width: auto;
			height: auto;
			margin: 5px 15px 0 0;
		}

		&.selected {
			background-color: rgba(220, 220, 220, 0.3) !important;

			.select-box .small-box {
				display: block;
			}
		}

		&.policy {
			.name {
				font-size: 12px;
				text-transform: uppercase;
				font-weight: 600;
			}
			.amount {
				font-weight: 600;
			}
			.cover-date {
				font-size: 12px;
				font-weight: 600;
			}
		}
		&.claim-type {
			.name {
				font-size: 13px;
				text-transform: uppercase;
				font-weight: 600;
			}
			.desc {
				font-size: 12px;
			}
		}

		.image-box {
			margin: 0 30px 0 0;

			.image {
				border-radius: 4px;
				width: auto;
				height: auto;
				max-width: 80px;
				max-height: 80px;
				margin: 5px 0 0 0;
			}
		}
		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}
		.name-box {
			width: calc(100% - 120px);
			.insurance {
				font-size: 14px;
				color: var(--text-color);
				font-weight: 600;
			}
			.txt {
				font-size: 13px;

				b {
					font-weight: 600;
					color: var(--ne-blue);
				}
			}
			.members {
				font-size: 13px;
				font-weight: 600;
				color: @grey;
				margin: 3px 0 10px 0;
			}
		}
	}
}
</style>
